<template>
  <Modal
    v-model="_value"
    width="500"
    title="查看潜在客户车辆信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <!--<p>业务状态：<label class="detailContent">{{potentialVehicleInfo.businessState}}</label></p>-->
    <!--<p>主机号码：<label class="detailContent">{{detail_commNO}}</label></p>-->
    <p>车牌号码：<label class="detailContent">{{potentialVehicleInfo.registrationNum}}</label></p>
<!--    <p>车牌颜色：<label class="detailContent">{{potentialVehicleInfo.registrationColor}}</label></p>-->
    <p>车辆类型：<label class="detailContent">{{potentialVehicleInfo.vehicleTypeName}}</label></p>
<!--    <p>车辆品牌：<label class="detailContent">{{potentialVehicleInfo.vehicleBrandName}}</label></p>-->
<!--    <p>车架号：<label class="detailContent">{{potentialVehicleInfo.frameNum}}</label></p>-->
<!--    <p>发动机号：<label class="detailContent">{{potentialVehicleInfo.engineNum}}</label></p>-->
<!--    <p>主机名称：<label class="detailContent">{{potentialVehicleInfo.deviceName}}</label></p>-->
<!--    <p>单位：<label class="detailContent">{{potentialVehicleInfo.customCompanyName}}</label> 联系人：<label-->
<!--    class="detailContent">{{potentialVehicleInfo.customCompanyContact}}</label>-->
<!--    联系电话：<label class="detailContent">{{potentialVehicleInfo.customCompanyContactPhone}}</label></p>-->
<!--    <p>所有人:<label class="detailContent">{{potentialVehicleInfo.vehicleOwnerName}}</label> 联系电话：<label-->
<!--    class="detailContent">{{potentialVehicleInfo.customCompanyContactPhone}}</label>-->
<!--    </p>-->
<!--    <p>车主身份证号码：<label class="detailContent">{{potentialVehicleInfo.vehicleOwnerIdcardNum}}</label></p>-->
    <p>联系地址:<label class="detailContent">{{potentialVehicleInfo.vehicleOwnerAddress}}</label></p>
    <p>联系人1:<label class="detailContent">{{potentialVehicleInfo.firstContactName}}</label>联系电话:<label
    class="detailContent">{{potentialVehicleInfo.firstContactPhone}}</label>
    <p>联系地址:<label class="detailContent">{{potentialVehicleInfo.firstContactAddress}}</label></p>
    <p>联系人2:<label class="detailContent">{{potentialVehicleInfo.secondContactName}}</label>联系电话:<label
    class="detailContent">{{potentialVehicleInfo.secondContactPhone}}</label>
    <p>联系地址:<label class="detailContent">{{potentialVehicleInfo.secondContactAddress}}</label></p>
    <p>联系人3:<label class="detailContent">{{potentialVehicleInfo.thirdContactName}}</label>联系电话:<label
    class="detailContent">{{potentialVehicleInfo.thirdContactPhone}}</label>
    <p>联系地址:<label class="detailContent">{{potentialVehicleInfo.thirdContactAddress}}</label></p>
    <!--<p>服务到期日期：<label class="detailContent">{{detail_serviceMatureDate | dataFormat}}</label></p>-->
<!--    <p>保险到期日期：<label class="detailContent">{{formatDate(potentialVehicleInfo.serviceMatureDate)}}</label></p>-->
<!--    <p>安装日期：<label class="detailContent">{{formatDate(potentialVehicleInfo.setupDate)}}</label></p>-->
<!--    <p>备注：<label class="detailContent">{{potentialVehicleInfo.remark}}</label></p>-->
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'PotentialDetailModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      potentialVehicleInfo: {
        // 车辆详细信息
        id: null,
        businessState: null,
        commNum: null,
        registrationNum: null,
        registrationColor: null,
        vehicleTypeName: null,
        vehicleBrandName: null,
        frameNum: null,
        engineNum: null,
        chassisNum: null,
        deviceName: null,
        customCompanyName: null,
        customCompanyContact: null,
        customCompanyContactPhone: null,
        vehicleOwnerName: null,
        vehicleOwnerPhone: null,
        vehicleOwnerAddress: null,
        vehicleOwnerIdcardNum: null,
        serviceMatureDate: null,
        setupDate: null,
        remark: null,
        firstContactName: null,
        firstContactPhone: null,
        firstContactAddress: null,
        secondContactName: null,
        secondContactPhone: null,
        secondContactAddress: null,
        thirdContactName: null,
        thirdContactPhone: null,
        thirdContactAddress: null
      }
    }
  },
  methods: {
    ...mapActions([
      'PotentialVehicleInfoServ_GetDetail'
    ]),
    formatDate (val) {
      let d = new Date(val)
      return d.Format('yyyy年MM月dd日')
    },
    visibleChange (val) {
      if (val) {
        this.potentialVehicleInfo.id = null
        this.potentialVehicleInfo.businessState = null
        this.potentialVehicleInfo.commNum = null
        this.potentialVehicleInfo.registrationNum = null
        this.potentialVehicleInfo.registrationColor = null
        this.potentialVehicleInfo.vehicleTypeName = null
        this.potentialVehicleInfo.vehicleBrandName = null
        this.potentialVehicleInfo.frameNum = null
        this.potentialVehicleInfo.engineNum = null
        this.potentialVehicleInfo.chassisNum = null
        this.potentialVehicleInfo.deviceName = null
        this.potentialVehicleInfo.customCompanyName = null
        this.potentialVehicleInfo.customCompanyContact = null
        this.potentialVehicleInfo.customCompanyContactPhone = null
        this.potentialVehicleInfo.vehicleOwnerName = null
        this.potentialVehicleInfo.vehicleOwnerPhone = null
        this.potentialVehicleInfo.vehicleOwnerAddress = null
        this.potentialVehicleInfo.vehicleOwnerIdcardNum = null
        this.potentialVehicleInfo.serviceMatureDate = null
        this.potentialVehicleInfo.setupDate = null
        this.potentialVehicleInfo.remark = null
        this.potentialVehicleInfo.firstContactName = null
        this.potentialVehicleInfo.firstContactPhone = null
        this.potentialVehicleInfo.firstContactAddress = null
        this.potentialVehicleInfo.secondContactName = null
        this.potentialVehicleInfo.secondContactPhone = null
        this.potentialVehicleInfo.secondContactAddress = null
        this.potentialVehicleInfo.thirdContactName = null
        this.potentialVehicleInfo.thirdContactPhone = null
        this.potentialVehicleInfo.thirdContactAddress = null

        let potentialVehicleInfoId = this._initValue
        if (potentialVehicleInfoId) {
          store.dispatch('PotentialVehicleInfoServ_GetDetail', {
            params: { id: potentialVehicleInfoId }
          }).then(() => {
            this.potentialVehicleInfo = store.getters.get_PotentialVehicleInfo_GetDetailResult
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<style scoped>
  .detailContent {
    color: blue;
  }
</style>
